module.exports = __webpack_public_path__ + "img/risk-none.e5fa94b3.png";